import moment from 'moment-timezone';

import { CSWidgetQuery, CSWidgetQueryPayload } from './CSWidgetQuery';
import type { CSCustomProperty } from '../types/CSCustomProperty';
import type { CSMultiSeries } from '../types/CSMultiSeries';
import type { CSNamedEvent } from '../types/CSNamedEvent';

interface CSTrendWidgetQueryPayload extends CSWidgetQueryPayload {
    countField: string;
    namedEvent: CSNamedEvent;
}

class CSTrendWidgetQuery extends CSWidgetQuery {
    private countField: string;
    private namedEvent: CSNamedEvent;

    constructor(
        countField: string,
        namedEvent: CSNamedEvent,
        multiSeries: CSMultiSeries,
        groupBys: CSCustomProperty[]
    ) {
        // Initialize with the specialized query type
        super('CSTrendWidgetQuery');
        this.countField = countField;
        this.namedEvent = namedEvent;
        this.multiSeries = multiSeries;
        this.groupBys = groupBys;
        this.shouldCalculateRangeBuckets = true;
        this.range = {
            startDate: moment().valueOf(),
            endDate: moment().valueOf(),
            period: 'daily',
        };
    }

    setCountField(field: string): this {
        this.countField = field;
        return this;
    }

    setNamedEvent(event: CSNamedEvent): this {
        this.namedEvent = event;
        return this;
    }

    // Override build to include additional fields.
    build(): CSTrendWidgetQueryPayload {
        return {
            ...super.build(),
            countField: this.countField,
            namedEvent: this.namedEvent,
        };
    }

    buildUrl(baseUrl: string): string {
        return `${baseUrl}/analytics/trendWidget`;
    }
}

export type { CSTrendWidgetQueryPayload };
export { CSTrendWidgetQuery };
